/**
 * Free play for local testing: play the main game without signing in or
 * paying, level after level, on local (unverified) seeds.
 * Only in builds made with REACT_APP_FREE_PLAY=true — never in production.
 */
export const FREE_PLAY = process.env.REACT_APP_FREE_PLAY === "true";
